import React, {Component} from "react";
import FlexView from "react-flexview";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";

class OnSubmissionDetailFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: {},
            dataVariant: [],
            dataWarna: [],
        };
    }

    render() {
        return (
            <SimpleModal
                title="Filter Search"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <FlexView column>
                            <SimpleInput
                                id="input_text_stnk_name"
                                name="namaSTNK"
                                label="Nama STNK"
                                value={this.props.filterData.namaSTNK}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_buyer_name"
                                name="namaPembeli"
                                label="Nama Pembeli"
                                value={this.props.filterData.namaPembeli}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_frame_number"
                                name="nomorRangka"
                                label="Nomor Rangka"
                                value={this.props.filterData.nomorRangka}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_engine_number"
                                name="nomorMesin"
                                label="Nomor Mesin"
                                value={this.props.filterData.nomorMesin}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                        </FlexView>
                        <FlexView hAlignContent="right" style={{gap: "10px"}}>
                            <SimpleButton
                                secondary
                                type="button"
                                text={"Clear"}
                                onClick={this.props.onClearForm}
                            />
                            <SimpleButton
                                type="submit"
                                text={"Terapkan"}
                                onClick={this.props.onSubmit}
                            />
                        </FlexView>

                        <SimpleLoadingOverlay active={this.state.loading}/>
                    </ModalContainer>
                }
            />
        );
    }
}

export default OnSubmissionDetailFilter;
